<template>
	<div class="sorting sidebar col-12">
		<h2 class="sidebarH2">Order By</h2>

		<div
			class="brandsFirstContainer"
			v-if="!isSpecials"	
		>
			<input
				v-model="brandsFirst"
				type="checkbox"
				name="brandsFirst"
				id="brandsFirst"
				@input="$parent.$emit('brandsFirstEvent', !brandsFirst)"
				class="displayOption sidebarCheckbox"
			>
			<label
				for="brandsFirst"
				class="sidebarLabel"
				:class="{current: brandsFirst}"
			>
				Brands First
			</label>
		</div>

		<div
			v-for="option in sortingOptions"
			:key="option[0]"
			class="orderbyRadioContainer"
		>
			<input
				:value="option[0]"
				class="displayOption sidebarRadio"
				type="radio"
				name="options"
				:id="option[1]"
				@input="$parent.$emit('sortingAlgoEvent', $event.target.value)"
				v-model="sortingAlgo"
			>
			<label 
				class="displayOptionText sidebarLabel" 
				:class="{current: sortingAlgo == option[0]}"
				:for="option[1]"
			>
				{{option[1]}}
			</label>
		</div>
	</div>
</template>

<script>

export default {
	name: 'OrderBy',
	data() {
		return {
			sortingAlgo: "TitleAZ",
			isSpecials: false,
			brandsFirst: false,
		}
	},
	created() {
		if (this.$route.name == "specials") {
			this.isSpecials = true;
			this.sortingAlgo = "recent"
		} else {
			this.isSpecials = false;
		}
	},
	components: {

	},
	computed: {
		sortingOptions() {
			let options = [];

			if (this.isSpecials) {
				options.push(["recent", "Recent"])
			}

			options.push(["TitleAZ", "A-Z"]);
			options.push(["TitleZA", "Z-A"]);

			//only available to logged in
			if(this.$store.state.auth.loggedIn){
				options.push(["priceLowHigh", "Lowest Price"]);
				options.push(["priceHighLow", "Highest Price"]);
			}

			options.push(["biggestSaving", "Biggest Saving"]);
			return options;
		},
	}
}
</script>

<style lang="scss" scoped>
	.sorting {

		.orderbyRadioContainer, .brandsFirstContainer {
			margin-bottom: 5px;
		}

		.displayOption {
			margin: 3px 3px 5px 4px;
		}

		.displayOptionText {
			&:hover {
				text-decoration: underline;
			}
			&.current {
				font-weight: bold;
			}
		}

		.sidebarLabel, .displayOption {
			cursor: pointer;
			vertical-align: middle;
		}

		.sidebarLabel {
			font-weight: normal;
			margin-bottom: 0;
			padding: 0;
			height: 100%;
		}
	}
</style>
